import { render, staticRenderFns } from "./FallbackSettings.vue?vue&type=template&id=70c486a6"
import script from "./FallbackSettings.vue?vue&type=script&lang=js"
export * from "./FallbackSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports